import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { DownloadModel } from '../shared/models/download.model';
import { DownloadService } from '../shared/services/download.service';
import { UserService } from '../shared/services/user.service';
import { DownloadEditComponent } from './download-edit/download-edit.component';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css']
})
export class DownloadComponent implements OnInit {
  @Input() category : string;
  @Input() subcategory : string;
  @Input() key : string;
  thisData : MatTableDataSource<any>;
  displayColumn : string[];//= ['date', 'title', 'version','model', 'releaseby', 'actions'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
  dialogConfig = new MatDialogConfig();

  constructor(
    public userService : UserService,
    private service : DownloadService,
    private router : Router,
    private dialog : MatDialog,
    //private toastr : ToastrService
    private gnotify : GlobalNotification) {
      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "60%";
      this.dialogConfig.minWidth="400px";
      this.dialogConfig.maxWidth="800px";
  }

  ngOnInit() {

    console.log(this.key);

    this.displayColumn = ['date', 'title', 'version', 'releaseby', 'actions'];

    if(this.category == "iot")
    {
      if(this.subcategory == "gateway")
      {
        this.displayColumn = ['date', 'title', 'version','model', 'releaseby', 'actions'];
      }
    }

    if(this.category == "actrl")
    {
      if(this.subcategory == "firmware")
      {
        this.displayColumn = ['date', 'title', 'version','model', 'releaseby', 'actions'];
      }
    }

    if(this.category == "cctv")
    {
      if(this.subcategory == "dvr-firmware" || this.subcategory == "camera-firmware")
      {
        this.displayColumn = ['date', 'title', 'version','model', 'releaseby', 'actions'];
      }
    }



    if(this.key == undefined) this.key = null;

    this.refreshList();
  }

  refreshList()
  {
    this.service.getList(this.category, this.subcategory, this.key).subscribe(
      res => {
        let array = res as DownloadModel[];
        this.thisData = new MatTableDataSource(array);
        this.thisData.sort = this.sort;
        this.thisData.paginator = this.paginator;
        this.applyFilter();
         console.log("refreshList : " + this.thisData.data.length);
         this.applyFilter();
       },
       err =>{
         console.log(err);
       }
    );

  }

  onCreate()
  {
    console.log("onCreate");
    this.service.initializeFormGroup(this.category, this.subcategory, this.key);
    this.dialogConfig.data = {
      result : false
    };

    let dialogRef = this.dialog.open(DownloadEditComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.refreshList();
      }

    });

  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {
    if(this.searchKey != null)
      this.thisData.filter = this.searchKey.trim().toLowerCase();
  }

  onDetail(fileId)
  {
   this.router.navigateByUrl('/download-detail/' + fileId);
  }

  onDelete(fileId)
  {
    if(!confirm("Are you sure to delete this file?")) return;

    this.service.deleteData(fileId).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "Download Delete");
        this.gnotify.showSnackBar('Download Delete', 'Submitted successfully', "warning");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

}
